import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { Voorraadbeheer } from '../types/Voorraadbeheer';
import { getOpstartDate } from '../utils/voorraadbeheer';

const useGetVoorraad = () => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<Voorraadbeheer[]> = async () => {
    const voorraadbeheerDatum = getOpstartDate('yyyy-MM-dd');
    const response = await fetchWithAuth(`/voorraadbeheer/${voorraadbeheerDatum}`);
    throwIfResponseNotOk(response, `Ophalen van voorraad is mislukt (${response.status}).`);
    return response.json();
  };

  return useQuery({
    queryKey: ['plankVoorraad'],
    queryFn: fetcher,
    refetchInterval: 10_000,
    meta: managedPageQueryMeta,
  });
};
export default useGetVoorraad;
